<template>
  <div id="exportar-raas">
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Exportar RAAS"
            description=""
            url=""
            :enabledModalInformacao="true"
            :enabledIframeModalInformacao="true"
            urlIframeModalInformacao="https://doc.clickup.com/9011510980/d/h/8cj1fp4-1631/599ea88448ce3d9/8cj1fp4-9191"
            pageIdentifier="exportar-raas"
          />
        </div>
      </div>
      <ValidationObserver ref="form">
        <div class="row mb-3 container-inputs">
          <div class="col-md-12">
            <fieldset class="bpa-fieldset">
              <legend class="bpa-fieldset__legend">
                Órgão Responsável pela Informação
              </legend>

              <div class="row">
                <div class="col-md-5">
                  <validation-provider v-slot="{ errors }" rules="required">
                    <label for="">Nome</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="form.rspNome"
                    />
                    <div class="error">{{ errors[0] }}</div>
                  </validation-provider>
                </div>

                <div class="col-md-3">
                  <validation-provider v-slot="{ errors }" rules="">
                    <label for="">Sigla</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="form.rspSigla"
                    />
                    <div class="error">{{ errors[0] }}</div>
                  </validation-provider>
                </div>

                <div class="col-md-4">
                  <validation-provider v-slot="{ errors }" rules="cnpj">
                    <label for="">CNPJ</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="form.rspCgcCpf"
                      v-inputmask="maskCnpj"
                    />
                    <div class="error">{{ errors[0] }}</div>
                  </validation-provider>
                </div>
              </div>
            </fieldset>
          </div>

          <div class="col-md-12">
            <fieldset class="bpa-fieldset">
              <legend class="bpa-fieldset__legend">
                Secretaria de Saúde de Destino
              </legend>
              <div class="row">
                <div class="col-md-5">
                  <validation-provider v-slot="{ errors }" rules="">
                    <label for="">Nome</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="form.destinoNome"
                    />
                    <div class="error">{{ errors[0] }}</div>
                  </validation-provider>
                </div>
                <div class="col-md-3">
                  <validation-provider v-slot="{ errors }" rules="required">
                    <label for="">Órgão destino</label>

                    <div class="d-flex align-items-center flex-wrap gap-2">
                      <b-form-radio v-model="form.destinoTipo" value="M" inline>
                        Municipal
                      </b-form-radio>

                      <b-form-radio v-model="form.destinoTipo" value="E" inline>
                        Estadual
                      </b-form-radio>
                    </div>

                    <div class="error">{{ errors[0] }}</div>
                  </validation-provider>
                </div>
              </div>
            </fieldset>
          </div>
          <div class="col-md-3">
            <validation-provider v-slot="{ errors }" rules="required">
              <label>Versão do sistema</label>

              <input
                type="text"
                class="form-control"
                v-model="form.versao"
                maxlength="5"
                placeholder="00.00"
              />

              <div class="error">{{ errors[0] }}</div>
            </validation-provider>
          </div>
          <div class="col-md-3">
            <validation-provider v-slot="{ errors }" rules="required">
              <label>Versão do BDSIA</label>

              <input
                type="text"
                class="form-control"
                v-model="form.bdVersao"
                maxlength="7"
              />

              <div class="error">{{ errors[0] }}</div>
            </validation-provider>
          </div>
          <div class="col-md-3">
            <validation-provider v-slot="{ errors }" rules="required">
              <label for="">Mês</label>
              <vue-select
                :options="monthOptions"
                label="label"
                placeholder=""
                v-model="form.mes"
                :clearable="false"
              >
                <template slot="option" slot-scope="option">
                  {{ option.label }}
                </template>
                <div slot="no-options">Não há opções correspondentes</div>
              </vue-select>
              <div class="error">{{ errors[0] }}</div>
            </validation-provider>
          </div>
          <div class="col-md-3">
            <validation-provider
              v-slot="{ errors }"
              rules="required|onlyNumbers|ano"
            >
              <label for="">Ano</label>
              <input
                type="text"
                class="form-control"
                placeholder=""
                v-model="form.ano"
                v-inputmask="maskNumbers"
                maxlength="4"
              />
              <div class="error">{{ errors[0] }}</div>
            </validation-provider>
          </div>

          <div class="col-md-6">
            <validation-provider v-slot="{ errors }" rules="required">
              <label for="">Unidade de saúde</label>
              <vue-select
                :options="estabelecimentos"
                label="no_unidade_saude"
                placeholder=""
                v-model="form.co_ubs"
                :loading="loadingSelectEstabelecimento"
              >
                <template slot="option" slot-scope="option">
                  {{ option.no_unidade_saude }}
                </template>
                <div slot="no-options">Não há opções correspondentes</div>
              </vue-select>
              <div class="error">{{ errors[0] }}</div>
            </validation-provider>
          </div>

          <div class="col-md-12">
            <div
              class="d-flex justify-content-start btn-actions"
              style="gap: 10px"
            >
              <button
                v-if="sigtapObrigatorio"
                class="btn btn-secondary"
                :disabled="loadingImportarSigtap"
                @click="$refs.modalImportarSigtap.abrir()"
              >
                <span
                  v-if="loadingImportarSigtap"
                  class="spinner-border spinner-border-sm me-2"
                ></span>

                {{
                  loadingImportarSigtap ? 'Importando...' : 'Importar SIGTAP'
                }}
              </button>

              <button
                class="btn btn-primary"
                :disabled="loading || !exportacaoLiberada"
                @click="exportar"
              >
                <span
                  v-if="loading"
                  class="spinner-border spinner-border-sm me-2"
                ></span>

                {{ loading ? 'Exportando...' : 'Exportar RAAS' }}
              </button>
            </div>

            <small
              v-if="sigtapObrigatorio && !exportacaoLiberada"
              class="text-muted d-block mt-2"
            >
              Importe o SIGTAP antes de exportar.
            </small>
          </div>
        </div>
      </ValidationObserver>
    </div>

    <ModalImportarSigtap
      ref="modalImportarSigtap"
      :loading="loadingImportarSigtap"
      @importar="importarSigtap"
    />
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from '@/components/SectionTitle'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { validations } from '@/mixins/validations'
validations()
import Masks from '@/mixins/masks'
import { MAP_TIPO_LOGRADOURO, normalizeTexto } from './utils.js'
import ModalImportarSigtap from '@/pages/BpaERas/components/ModalImportarSigtap.vue'

export default {
  name: 'ExportarRaas',
  components: {
    Menu,
    Footer,
    SectionTitle,
    ValidationObserver,
    ValidationProvider,
    ModalImportarSigtap,
  },
  data() {
    return {
      monthOptions: [
        { label: 'Janeiro', value: '01' },
        { label: 'Fevereiro', value: '02' },
        { label: 'Março', value: '03' },
        { label: 'Abril', value: '04' },
        { label: 'Maio', value: '05' },
        { label: 'Junho', value: '06' },
        { label: 'Julho', value: '07' },
        { label: 'Agosto', value: '08' },
        { label: 'Setembro', value: '09' },
        { label: 'Outubro', value: '10' },
        { label: 'Novembro', value: '11' },
        { label: 'Dezembro', value: '12' },
      ],
      form: {
        rspNome: '',
        rspSigla: '',
        rspCgcCpf: '',
        destinoNome: '',
        destinoTipo: 'M',
        versao: '',
        bdVersao: '',
        mes: null,
        ano: '',
        co_ubs: '',
      },
      loading: false,
      errorMsg: '',
      loadingSelectEstabelecimento: false,
      estabelecimentos: [],
      loadingImportarSigtap: false,
      exportacaoLiberada: false,
      sigtapObrigatorio: false,
    }
  },
  computed: {
    maskNumbers() {
      return Masks['number']
    },
    maskCnpj() {
      return Masks['cnpj']
    },
  },
  created() {
    this.carregarSelectEstabelecimentos()
    this.verificarSigtap()
  },
  methods: {
    /**
     * Verifica se o SIGTAP precisa ser importado antes da exportação.
     *
     * @returns {Promise<void>}
     */
    async verificarSigtap() {
      try {
        const response = await this.$api.get(
          `/app/bpa/${this.$store.state.cod_ibge}/verificar-sigtap`
        )

        const obrigatorio = Number(response?.data.update_tp_registro) === 1

        this.sigtapObrigatorio = obrigatorio

        // Se não for obrigatório, já libera exportação
        this.exportacaoLiberada = !obrigatorio
      } catch (error) {
        console.log(error)

        // Em caso de erro, mantém bloqueado
        this.sigtapObrigatorio = true
        this.exportacaoLiberada = false
      }
    },

    /**
     * Envia os arquivos SIGTAP para importação.
     *
     * @param {Object} arquivos Arquivos selecionados no modal
     * @returns {Promise<void>}
     */
    async importarSigtap(arquivos) {
      try {
        this.errorMsg = ''
        this.exportacaoLiberada = false
        this.loadingImportarSigtap = true

        const formData = new FormData()

        formData.append(
          'rl_procedimento_registro',
          arquivos.rl_procedimento_registro
        )

        formData.append(
          'rl_procedimento_detalhe',
          arquivos.rl_procedimento_detalhe
        )

        formData.append(
          'tb_servico_classificacao',
          arquivos.tb_servico_classificacao
        )

        formData.append(
          'rl_procedimento_servico',
          arquivos.rl_procedimento_servico
        )

        const response = await this.$api.post(
          '/app/bpa/importar-sigtap',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          }
        )

        if (response?.data?.success === true) {
          this.$toast?.success?.(
            response?.data?.message || 'SIGTAP importado com sucesso.'
          )

          this.$refs.modalImportarSigtap.fechar()

          await this.verificarSigtap()

          return
        }

        this.exportacaoLiberada = false

        this.$toast?.error?.(
          response?.data?.message || 'Não foi possível importar o SIGTAP.'
        )
      } catch (error) {
        console.log(error)

        this.exportacaoLiberada = false

        this.$toast?.error?.(
          error?.response?.data?.message ||
            'Erro ao importar SIGTAP. Tente novamente.'
        )
      } finally {
        this.loadingImportarSigtap = false
      }
    },

    /**
     * Exporta os dados no formato RAAS.
     *
     * @returns {Promise<void>}
     */
    async exportar() {
      try {
        const isValid = await this.$refs.form.validate()

        if (!isValid) {
          return false
        }

        if (this.sigtapObrigatorio && !this.exportacaoLiberada) {
          this.$toast?.error?.('Importe o SIGTAP antes de exportar.')

          return false
        }

        this.errorMsg = ''
        this.loading = true

        const response = await this.$api.post(
          '/app/raas/exportar',
          {
            co_ibge: this.$store.state.cod_ibge,
            mes_ano: `${this.form.mes.value}-${this.form.ano}`,
            co_ubs: this.form.co_ubs.co_ubs,
            rsp_nome: this.form.rspNome,
            rsp_sigla: this.form.rspSigla,
            rsp_cgc_cpf: this.form.rspCgcCpf,
            destino_nome: this.form.destinoNome,
            destino_tipo: this.form.destinoTipo,
            versao: this.form.versao,
            bd_versao: this.form.bdVersao,
          },
          {
            responseType: 'blob',
          }
        )

        const blob = new Blob([response.data], {
          type: 'text/plain;charset=windows-1252',
        })

        const contentDisposition = response.headers['content-disposition']

        let nomeArquivo = 'RAAS.txt'

        if (contentDisposition) {
          const match = contentDisposition.match(/filename="?([^"]+)"?/)

          if (match?.[1]) {
            nomeArquivo = match[1]
          }
        }

        const url = URL.createObjectURL(blob)

        const a = document.createElement('a')

        a.href = url
        a.download = nomeArquivo

        document.body.appendChild(a)

        a.click()

        document.body.removeChild(a)

        URL.revokeObjectURL(url)
      } catch (error) {
        console.error(error)

        let message = 'Erro ao exportar o arquivo. Tente novamente.'

        /**
         * Como a resposta é Blob, erros JSON retornados pelo backend
         * também chegam como Blob.
         */
        if (error?.response?.data instanceof Blob) {
          try {
            const text = await error.response.data.text()
            const data = JSON.parse(text)

            message = data?.message || message
          } catch (e) {
            // Mantém a mensagem padrão.
          }
        } else {
          message = error?.response?.data?.message || error?.message || message
        }

        this.errorMsg = message

        this.$toast?.error?.(message)
      } finally {
        this.loading = false
      }
    },

    /**
     * Carrega os estabelecimentos de saúde
     */
    async carregarSelectEstabelecimentos() {
      try {
        this.loadingSelectEstabelecimento = true
        let response = await this.$api.get(
          `/app/relatorio-atendimentos/${this.$store.state.cod_ibge}/unidades-de-saude`
        )
        if (response) {
          this.estabelecimentos = response.data
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loadingSelectEstabelecimento = false
      }
    },
  },
}
</script>

<style scoped lang="scss">
#exportar-raas {
  .container-inputs > div {
    margin-top: 15px;
  }
  .tipo-export__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 10px;
  }

  .tipo-export__title {
    color: #000;
  }

  .tipo-export__badge {
    font-size: 12px;
    padding: 6px 10px;
    border-radius: 999px;
    color: #000;
    background: rgba(102, 126, 234, 0.12);
    border: 1px solid rgba(102, 126, 234, 0.35);
    white-space: nowrap;
  }

  .tipo-export__info {
    background: rgba(102, 126, 234, 0.1);
    border: 1px solid rgba(102, 126, 234, 0.28);
    border-radius: 14px;
    padding: 14px 16px;
    margin-bottom: 12px;
    color: #000;
  }

  .tipo-export__info-title {
    font-weight: 700;
    color: #000;
    margin-bottom: 6px;
  }

  .tipo-export__info-text {
    line-height: 1.35;
    color: 000;

    b {
      color: #000;
      font-weight: 700;
    }
  }

  .tipo-export__group {
    display: flex;
    gap: 12px;
  }

  .tipo-export__option {
    display: flex;
    flex: 1;
    align-items: flex-start;
    gap: 12px;
    padding: 14px 16px;
    border-radius: 14px;
    cursor: pointer;
    user-select: none;

    background: rgba(0, 0, 0, 0.12);
    border: 1px solid rgba(255, 255, 255, 0.1);
    color: #000;

    transition: transform 0.05s ease, border-color 0.15s ease,
      background-color 0.15s ease;
  }

  .tipo-export__option:hover {
    border-color: rgba(255, 255, 255, 0.18);
    background: rgba(0, 0, 0, 0.16);
  }

  .tipo-export__option.is-active {
    border-color: rgba(102, 126, 234, 0.7);
    background: rgba(102, 126, 234, 0.12);
  }

  .tipo-export__radio {
    margin-top: 2px;
    margin-right: 0;
    .custom-control {
      min-height: auto;
    }
  }

  .tipo-export__option-title {
    font-weight: 700;
    color: #000;
    margin-bottom: 2px;
  }

  .tipo-export__option-desc {
    font-size: 13px;
    line-height: 1.25;
    color: #000;
  }

  .bpa-fieldset {
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 14px;
    padding: 14px 16px 16px;
    margin-top: 10px;
    background: rgba(0, 0, 0, 0.03);
    min-inline-size: auto;
  }

  .bpa-fieldset__legend {
    font-weight: 700;
    font-size: 13px;
    padding: 0 8px;
    margin: 0;
    width: auto;
    color: #000;
    border-radius: 999px;
  }

  .btn-actions {
    .btn-primary:disabled,
    .btn-primary.disabled {
      background: #adb5bd !important;
      border-color: #adb5bd !important;
      color: #495057 !important;
      cursor: not-allowed;
      opacity: 1;
    }
  }
}
</style>
